import ForgotPasswordFormBackOffice from './forgot-password-form';

export default ForgotPasswordFormBackOffice;
